<script>
export default {
  name: 'PlacementPeriod',
  props: {
    bookings: {
      type: Array,
      default: () => {
        return [
          {
            ID: 777123,
          },
        ]
      },
    },
  },
}
</script>

<template>
  <div class="placementInfo">
    {{ bookings.length }}
  </div>
</template>
